(function () {
  "use strict";
  const html = (strings, ...values) =>
    String.raw({ raw: strings }, ...values.map((v) => String(v)));

  const cachedOrders = [];

  const section = document.querySelector("#statusFormSection");
  const sectionId = section.dataset.sectionId;

  const formContainer = section.querySelector(
    "#statusFormContainer-" + sectionId
  );
  const form = formContainer.querySelector("#orderStatusForm-" + sectionId);
  const submitBtn = form.querySelector("#status-form-submit-" + sectionId);
  const numberInput = form.querySelector("#StatusFormOrderNumber-" + sectionId);
  const numberError = form.querySelector("[data-error-number]");
  const zipInput = form.querySelector("#StatusFormZip-" + sectionId);
  const zipError = form.querySelector("[data-error-zip]");

  const resultContainer = section.querySelector(
    "#statusFormResult-" + sectionId
  );
  const formResultDetails = resultContainer.querySelector(
    "#formResultDetails-" + sectionId
  );
  const resultOrderNumSpan = resultContainer.querySelector(
    ".section-header__title span"
  );
  const resetBtn = resultContainer.querySelector(
    "#statusResetBtn-" + sectionId
  );
  const template = section.querySelector("#orderItemTemplate");
  const formErrorsContainer = formContainer.querySelector("#statusFormErrors");
  const formErrors = { number: false, zip: false };

  form.addEventListener("submit", (event) => {
    event.preventDefault();
    const formData = new FormData(form);
    getOrderStatus(formData, "form");
  });

  resetBtn.addEventListener("click", () => {
    resetForm();
    pushHistoryState("");
  });

  checkSearchParams();
  bindBackButton();

  function checkSearchParams() {
    const currentParams = new URLSearchParams(window.location.search);
    if (currentParams.has("orderNumber") && currentParams.has("zip")) {
      const formData = new FormData();
      formData.set("orderNumber", currentParams.get("orderNumber"));
      formData.set("zip", currentParams.get("zip"));
      const cachedOrder = cachedOrders.find(
        (order) =>
          order.orderNumber === formData.get("orderNumber") &&
          order.zip === formData.get("zip")
      );
      cachedOrder
        ? setupFromCached(cachedOrder)
        : getOrderStatus(formData, "search");
      formContainer.classList.add("hide");
      resultContainer.classList.remove("hide");
    }
  }

  function getOrderStatus(formData, from) {
    if (validateForm(formData)) return;

    const orderNumber = formData.get("orderNumber");
    resultOrderNumSpan.innerText = "#" + orderNumber;
    if (from === "form") {
      submitBtn.classList.add("btn--loading");
      submitBtn.disabled = true;
    } else {
      resultContainer.classList.add("unload");
    }
    fetch(window.Shopify.routes.root + "apps/jkcustom/status-form", {
      method: "POST",
      body: formData,
    })
      .then(function (response) {
        if (response.status !== 200) {
          throw new Error(
            response.status === 400 ? "Bad Request" : response.statusText
          );
        }
        return response.json();
      })
      .then(function (body) {
        cachedOrders.push({
          data: body.data,
          orderNumber,
          zip: formData.get("zip"),
        });
        setupResult(body.data, orderNumber);
        formContainer.classList.add("hide");
        resultContainer.classList.remove("hide");
        const queryString = new URLSearchParams(formData);
        pushHistoryState(queryString);
      })
      .catch((err) => {
        if (from === "search") {
          history.replaceState({}, "", window.location.pathname);
          resetForm();
        } else {
          formErrorsContainer.innerHTML =
            err.message === "Bad Request"
              ? "No order under that number and/or zip code was found. Please enter a valid combination."
              : "Error getting order status, please try again.";
          formErrorsContainer.classList.remove("hide");
        }
      })
      .finally(() => {
        if (from === "form") {
          submitBtn.classList.remove("btn--loading");
          submitBtn.disabled = false;
        } else {
          resultContainer.classList.remove("unload");
        }
      });
  }

  function validateForm(data) {
    formErrorsContainer.innerHTML = "";
    formErrorsContainer.classList.add("hide");
    formErrors.number =
      !data.get("orderNumber") || data.get("orderNumber").trim() === "";
    formErrors.zip = !data.get("zip") || data.get("zip").trim() === "";

    if (formErrors.number) {
      numberInput.classList.add("input-error");
      numberError.innerHTML = "Order number is required";
    } else {
      numberInput.classList.remove("input-error");
      numberError.innerHTML = "Error Message";
    }

    if (formErrors.zip) {
      zipInput.classList.add("input-error");
      zipError.innerHTML = "Zip code is required";
    } else {
      zipInput.classList.remove("input-error");
      zipError.innerHTML = "Error Message";
    }
    return formErrors.number || formErrors.zip;
  }

  function setupResult(order, orderNumber) {
    const resultItemList = resultContainer.querySelector(".order-item--list");
    formResultDetails.innerHTML = `
            <span><strong>Order Date:</strong> ${getFormattedDate(
              order.orderDate
            )}</span>
            <span class="rte"><a href="https://contact.gorgias.help/forms/bwbq3q4m" target="_blank">Contact Customer Service</a></span>
        `;

    if (order.products) {
      order.products.forEach((product, idx) => {
        createOrderItem(product, resultItemList);
      });
    } else if (order.fulfillmentProducts) {
      order.fulfillmentProducts.forEach((product) => {
        createFulfillmentItem(product, resultItemList);
      });
    }
  }

  function setupFromCached(order) {
    resultContainer.querySelector(".order-item--list").innerHTML = "";
    setupResult(order.data, order.orderNumber);
    resultContainer.classList.remove("unload");
  }

  function createFulfillmentItem(product, listContainer) {
    console.log(product);
    const image_responsive_url = window.theme.Images.buildImagePath(
      product.shop.image
    );
    const image_responsive_urls = window.theme.Images.buildImagePath(
      product.shop.image,
      [180, 360, 540]
    );
    const url = `https://account.jkboots.com/orders/${product.orderId}`;
    const trackingText = product.trackingNumber
      ? `${product.trackingCompany} 
              <a href="${product.trackingUrl}" target="_blank">${product.trackingNumber}</a>`
      : `No tracking data available, contact customer service for more information`;
    const displayStatus = capFirst(
      (product.fulfillment?.displayStatus
        ? product.fulfillment.displayStatus
        : product.shipmentStatus
      )
        .toLowerCase()
        .replaceAll("_", " ")
    );
    const dsClass =
      displayStatus === "Delivered"
        ? " ontime"
        : displayStatus === "delayed"
        ? " delayed"
        : displayStatus === "failure"
        ? " error"
        : "";
    const deliveryDate = fulfillmentDate(product.fulfillment);
    const orderItemEl = document.createElement("div");
    orderItemEl.className = "order__item";
    orderItemEl.innerHTML = html`
      <div class="order__image">
        <a
          href="${url}"
          class="image-wrap loaded orderItemImageLink"
          style="height:0; padding-bottom:100%;"
        >
          <image-element
            data-aos="image-fade-in"
            data-aos-offset="100"
            class="aos-init aos-animate"
          >
            <img
              src="${image_responsive_url}"
              alt="${product.imageAlt}"
              srcset="${image_responsive_urls.toString()}"
              loading="lazy"
              class="image-element"
              sizes="100px"
            />
          </image-element>
        </a>
      </div>
      <div class="order__item-details">
        <div class="order__item-main">
          <div class="order__item-dates">
            <a href="${url}" class="order__item-name orderItemTitleLink">
              <strong>${product.shop.title}</strong>
              ${product.shop.variantTitle !== "Default Title"
                ? ` <span style="font-size: 0.85em;margin-left:0.25rem;">${product.shop.variantTitle}</span>`
                : ""}
            </a>
            <div class="rte">
              ${deliveryDate ? `<strong>${deliveryDate}</strong>` : ""}
              <div>${trackingText}</div>
            </div>
          </div>
          <div>
            <span class="details-item--status badge${dsClass}">
              ${displayStatus}
            </span>
          </div>
        </div>
      </div>
    `;
    listContainer.appendChild(orderItemEl);
  }

  function createOrderItem(product, listContainer) {
    const image_responsive_url = window.theme.Images.buildImagePath(
      product.image
    );
    const image_responsive_urls = window.theme.Images.buildImagePath(
      product.image,
      [180, 360, 540]
    );
    const url = `/products/${product.handle}`;

    const completionDateMarkup = product.inStock
      ? `<strong>Projected fulfillment:</strong><div class="date-range-wrapper">1 - 5 business days from order date</div>`
      : `<strong>${
          !product.onTime ? "Original " : ""
        }Completion Date Range:</strong> <div class="date-range-wrapper">${getFormattedDate(
          product.quotedCompletionDate
        )} - ${getFormattedDate(product.upperCompletionDate)}</div>`;

    const projectedDateMarkup = !product.onTime
      ? `<div class="projected-range"><strong>Projected Completion Date Range:</strong> <div>${getFormattedDate(
          product.projectedCompletionDate
        )} - ${getFormattedDate(
          product.upperProjectedCompletionDate
        )}</div></div>`
      : "";

    const orderItemEl = document.createElement("div");
    orderItemEl.className = "order__item";
    orderItemEl.innerHTML = html`
      <div class="order__image">
        <a
          href="${url}"
          class="image-wrap loaded orderItemImageLink"
          style="height:0; padding-bottom:100%;"
        >
          <image-element
            data-aos="image-fade-in"
            data-aos-offset="100"
            class="aos-init aos-animate"
          >
            <img
              src="${image_responsive_url}"
              alt="${product.imageAlt}"
              srcset="${image_responsive_urls.toString()}"
              loading="lazy"
              class="image-element"
              sizes="100px"
            />
          </image-element>
        </a>
      </div>
      <div class="order__item-details">
        <div class="order__item-main">
          <div class="order__item-dates">
            <a href="${url}" class="order__item-name orderItemTitleLink">
              <strong>${product.title}</strong>
            </a>
            <div>${completionDateMarkup}</div>
            ${projectedDateMarkup}
          </div>
          <div>
            <span
              class="details-item--status badge ${product.onTime
                ? "ontime"
                : "delayed"}"
            >
              ${product.inStock
                ? "In Stock"
                : product.onTime
                ? "On Time"
                : "Delayed"}
            </span>
          </div>
        </div>
      </div>
    `;
    listContainer.appendChild(orderItemEl);
  }

  function resetForm() {
    form.reset();
    resultContainer.classList.add("hide");
    formContainer.classList.remove("hide");
    resultContainer.querySelector(".order-item--list").innerHTML = "";
    resultOrderNumSpan.innerHTML = "";
    formResultDetails.innerHTML = "";
  }

  function getFormattedDate(date) {
    const event = new Date(date);
    const options = {
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    //return date.toDateString();
    return event.toLocaleDateString(undefined, options);
  }

  function fulfillmentDate(fulfillment) {
    const currentYear = new Date().getFullYear();

    return fulfillment?.deliveredAt
      ? `Arrived ${getDateString(fulfillment.deliveredAt)}`
      : fulfillment?.estimatedDeliveryAt
      ? `Expected ${getDateString(fulfillment.estimatedDeliveryAt)}`
      : "";

    function getDateString(date) {
      const deliveryDate = new Date(date);
      const yrDisp =
        deliveryDate.getFullYear() !== currentYear ? "numeric" : undefined;
      return deliveryDate.toLocaleDateString(undefined, {
        year: yrDisp,
        month: "long",
        day: "numeric",
      });
    }
  }

  function pushHistoryState(searchParams) {
    history.pushState(
      {},
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`
    );
  }

  function bindBackButton() {
    window.on("popstate", function (state) {
      if (state) {
        var newUrl = new URL(window.location.href);
        if (newUrl.searchParams.size > 0) {
          checkSearchParams();
        } else {
          resetForm();
        }
      }
    });
  }

  function capFirst(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
})();
